/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chevron-bottom': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#000" d="M13.293 4.293l1.414 1.414L8 12.414 1.293 5.707l1.414-1.414L8 9.586z" fill-rule="evenodd"/>'
  }
})
